import { render, staticRenderFns } from "./b-multi-email-modal.vue?vue&type=template&id=2634e4b6&scoped=true"
import script from "./b-multi-email-modal.vue?vue&type=script&lang=js"
export * from "./b-multi-email-modal.vue?vue&type=script&lang=js"
import style0 from "./b-multi-email-modal.vue?vue&type=style&index=0&id=2634e4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634e4b6",
  null
  
)

export default component.exports